import { render, staticRenderFns } from "./PageHomepageBelowUniqueSellingPointsHook.vue?vue&type=template&id=54be7006&"
import script from "./PageHomepageBelowUniqueSellingPointsHook.js?vue&type=script&lang=js&"
export * from "./PageHomepageBelowUniqueSellingPointsHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports